import jwtDecode from 'jwt-decode';

export interface UserJWT {
  unique_name: string;
  nameid: string;
  tablet: string;
  _log: string;
  cn: string;
  Department: string;
  CompanyName: string;
  firstName: string;
  parent: string;
  apiVersion: string;
  nbf: number;
  exp: number;
  iat: number;
  tabId: string;
  Groups: string;
  group?: string | string[];
  [key: string]: unknown;
}

export const emptyUserJWT: UserJWT = {
  unique_name: '',
  nameid: '',
  tablet: '',
  _log: '',
  cn: '',
  Department: '',
  CompanyName: '',
  firstName: '',
  parent: '',
  apiVersion: '',
  nbf: 0,
  exp: 0,
  iat: 0,
  tabId: '',
  Groups: '',
  group: '',
};

export const sampleUserJWT: UserJWT = {
  unique_name: 'FIR998',
  nameid: 'FIR998',
  tablet: 'pc',
  _log: 'RklSOTk4OlZpdGVjMTIzIQ==',
  cn: 'FIR998',
  Department: '998',
  CompanyName: 'AUTO-MESSEN 2018 AS           ',
  firstName: 'FIR998',
  parent: '0',
  apiVersion: '3.2.96',
  nbf: 1772694849,
  exp: 1772781249,
  iat: 1772694849,
  tabId: '1772693940445',
  Groups: '01, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13, 15, 17, 18, 19, 20, 21, 22, 25, 26, 31, 32, 33, ALLUSERS',
};

export const getUserJWTGroups = (userJWT?: UserJWT): string[] => {
  const groupsFromGroupsClaim = (userJWT?.Groups || '')
    .split(',')
    .map((group) => group.trim())
    .filter(Boolean);

  const groupsFromGroupClaim = Array.isArray(userJWT?.group)
    ? userJWT.group.map((group) => String(group).trim()).filter(Boolean)
    : userJWT?.group
      ? [String(userJWT.group).trim()]
      : [];

  return Array.from(new Set([...groupsFromGroupsClaim, ...groupsFromGroupClaim]));
};

/**
 * TEMPORARY (NVCMP): product info comparison test page — remove when COBOL product info is retired.
 * Brukere med brukernavn som starter med "FIR" (f.eks. FIR998) ser testsiden for sammenligning av vareinfo (NVCMP).
 * Backend (/product/infocompare) sjekker det samme.
 * Ved sidelasting (direkte URL) er state.auth.userJWT ikke satt ennå når rutene bygges første gang;
 * da leses brukernavnet fra tokenet i sessionStorage, ellers sender catch-all-ruten brukeren til /menu.
 */
export const isFirUser = (userJWT?: UserJWT): boolean => {
  let username = userJWT?.unique_name;
  if (!username) {
    const token = sessionStorage.getItem('token');
    if (token) {
      try {
        username = (jwtDecode(token) as Partial<UserJWT>).unique_name;
      } catch {
        username = undefined;
      }
    }
  }
  return String(username ?? '').trim().toUpperCase().startsWith('FIR');
};
